import { Resources } from '@shared/localizations/Resources';
import { SlTpUtils } from '../Trading/SlTpUtils';
export function formatTicks(value, instrument, offsetType) {
    const ticksVisualOffsetType = SlTpUtils.getDefaultVisualOffsetTypeExcludePercent(instrument, offsetType);
    const ticksVisualOffsetValue = SlTpUtils.toVisualValue(value, instrument, ticksVisualOffsetType);
    const formattedTicksVisualOffsetValue = SlTpUtils.formatSLTPValue(ticksVisualOffsetValue, instrument, ticksVisualOffsetType);
    return `${formattedTicksVisualOffsetValue} ${Resources.getResource(SlTpUtils.getLocalizationForOffsetMode(ticksVisualOffsetType))}`;
}
